import type { PureQueryOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { graphql } from '~/apollo/generated/v4';

export const REMOVE_OUTCROP_LINK = graphql(`
  mutation PaleoMapRemoveOutcropLink($input: PaleoMapRemoveOutcropLinkInput!) {
    paleoMapRemoveOutcropLink(input: $input)
  }
`);

type Props = {
  children: (
    handleDelete: () => Promise<void>,
    loading: boolean,
  ) => JSX.Element;
  paleoMapId: number;
  outcropId: number;
  refetchQueries: PureQueryOptions[];
};

export function RemovePaleoMapOutcropLink({
  children,
  paleoMapId,
  outcropId,
  refetchQueries,
}: Props) {
  const [removeLink, { loading }] = useMutation(REMOVE_OUTCROP_LINK, {
    variables: { input: { paleoMapId, outcropId } },
    refetchQueries,
  });

  async function handleDelete() {
    try {
      await removeLink();
      toast.success('Outcrop unlinked successfully.');
    } catch (err) {
      console.log('Error unlinking outcrop', err);
      toast.error(
        'There was a problem unlinking the outcrop, please refresh the page and try again.',
      );
    }
  }

  return children(handleDelete, loading);
}
